export function createResizeObserver(callback: ResizeObserverCallback) {
    return typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(callback);
}
